import _ from 'lodash';

import connect from 'components/lib/connect';
import DeleteTeam from 'actions/teams/delete_team';
import NavigateBackToUsersAdmin from 'actions/users/navigate_back_to_users_admin';
import SaveTeam from 'actions/teams/save_team';
import TeamEditor from './team_editor';
import Team from 'models/team';

function mapStateToProps({ getProvider }) {
  const agentProvider = getProvider('agents');
  const currentAgent = getProvider('currentAgent').get();
  const teamsProvider = getProvider('teams');

  let isLoading = teamsProvider.isLoading() || agentProvider.isLoading();
  let teamId = getProvider('currentLocation').get().teamId;
  let team = new Team();
  let errors = [];
  let isPendingDelete = false;
  let isPendingSave = false;

  if (!isLoading) {
    let existingTeam = teamId && teamsProvider.findBy({ id: teamId });
    if (existingTeam) {
      // team that is being loaded exists
      team = existingTeam;
      isPendingDelete = teamsProvider.isPendingDelete(teamId);
      errors = teamsProvider.getErrors(teamId);
      isPendingSave = teamsProvider.isPending(teamId);
    } else {
      errors = teamsProvider.getErrorsForNew();
      isPendingSave = teamsProvider.isPendingNew();
    }
  }

  let createdBy = _.get(team, 'createdBy');
  if (createdBy) {
    const you = createdBy === _.get(currentAgent, 'id') ? ' (You)' : '';
    let agent = agentProvider.findBy({ id: createdBy });
    createdBy = agent && `${agent.name || agent.email}${you}`;
  }

  return {
    createdBy,
    errors,
    isLoading,
    isPendingDelete,
    isPendingSave,
    team,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onCancel: () => executeAction(NavigateBackToUsersAdmin),
    onDelete: teamId => executeAction(DeleteTeam, teamId),
    onSubmit: attrs => executeAction(SaveTeam, attrs),
  };
}

const TeamEditorContainer = connect(mapStateToProps, mapExecuteToProps)(TeamEditor);
export default TeamEditorContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_editor/team_editor_container.js